export default "__VITE_ASSET__CXitVNlQ__"